import React, { Component } from 'react';
import { Template1, Template2, Template3, Template4 } from '../components/_index';
import { E404 } from './404';
import withRouter from '../services/withRouter';
import Helper from '../services/Helper'
import { consts, lang } from '../services/_consts';
import { cvEng } from '../services/_templateData';
import CvMakerContext from '../services/app-context';

class Cv extends Component {
    static displayName = Cv.name;
    static contextType = CvMakerContext;

    style = {
        menu: {
            position: 'absolute',
            padding: '0px 0',
            background: 'white',
            borderRadius: '10px',
            border: '1px solid #c8c8c8',
            overflow: 'hidden',
            marginLeft: '-50px',
            marginTop: '6px',
            boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)'
        },
        las: {
            color: 'red',
            margin: '0 4px',
            fontSize: '24px'
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            loading: true,
            cv: cvEng
        }
    }

    componentDidMount() {

        let { id, fullName } = this.props.params;
        this.getCv(id, fullName);
    }

    getCv = async (id, fullName) => {
        this.setState({ error: false, loading: true });
        const data = await Helper.callApiAsJson({
            url: `/resume/FindResume/${id}/${fullName}`, type: 'get'
        })

        if (data) {
            let resume = Helper.decode(data.text);
            this.setState({ template: 0 }, () => {
                document.title = resume.cv.fullName + "-CVMaker";
                this.setState({
                    template: resume.template,
                    cv: { ...resume.cv, id: id }
                    , loading: false
                });
            });

            setTimeout(() => {
                document.querySelectorAll('[contenteditable="true"]')
                    .forEach(b => b.removeAttribute('contenteditable'));
            }, 1000);
        }
        else
            this.setState({ error: true, loading: false });
    }

    printCv = () => {
        //document.getElementById('toollbar').classList.add('d-none');
        window.print()
        //document.getElementById('toollbar').classList.remove('d-none');

        //var divContents = document.getElementById("GFG").innerHTML;
        //var head = document.getElementsByTagName('head')[0].innerHTML;
        //debugger;
        //var a = window.open('', '', 'height=500, width=500');
        //a.document.write('<html>');
        //a.document.write('<head>' + head + '<style></style>' + '</head>');
        //a.document.write('<body >');
        //a.document.write(divContents);
        //a.document.write('</body></html>');
        //a.document.close();
        //a.print();
    }


    render() {
        return (
            <>
                <button onClick={() => { this.printCv() }}
                    style={{ position: 'fixed', top: '14px', zIndex: '30', margin: '0 14px' }}
                    className="btn btn-dark btn-sm">{this.context.lang.print} <i className="las la-print"></i></button>



                <div id="GFG" className={`${this.state.cv.rtl ? 'rtl' : 'ltr'} bg-white a4 text-center`}
                    style={{
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}>
                    {this.state.loading && <div>loading....</div>}
                    {this.state.error && <E404></E404>}
                    {this.state.template == 1 && <Template1 cv={this.state.cv} readonly />}
                    {this.state.template == 2 && <Template2 cv={this.state.cv} readonly />}
                    {this.state.template == 3 && <Template3 cv={this.state.cv} readonly />}
                    {this.state.template == 4 && <Template4 cv={this.state.cv} readonly />}
                    {this.state.template == 4 && <Template4 cv={this.state.cv} readonly />}
                </div>

            </>
        );
    }
}
export const CvWithRouter = withRouter(Cv);